module.exports = __webpack_public_path__ + "static/media/addRecipientGuide1_Jap.c9902db3.png";